import React, { useMemo, useState } from "react";
import { Popover } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import "./ManageBookingActions.scss";

type ActionRenderer = (closeDropdown: () => void) => React.ReactNode;

interface ManageBookingActionsProps {
  renderReschedule?: ActionRenderer;
  renderCancel?: ActionRenderer;
  className?: string;
}

const ManageBookingActions: React.FC<ManageBookingActionsProps> = ({
  renderReschedule,
  renderCancel,
  className = "",
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const closeDropdown = () => {
    setOpen(false);
  };

  const hasReschedule = typeof renderReschedule === "function";
  const hasCancel = typeof renderCancel === "function";
  const hasActions = hasReschedule || hasCancel;

  const menu = useMemo(() => {
    if (!hasActions) return null;

    return (
      <div className="manage-booking-actions__menu">
        {hasReschedule && renderReschedule?.(closeDropdown)}
        {hasCancel && renderCancel?.(closeDropdown)}
      </div>
    );
  }, [hasActions, hasCancel, hasReschedule, renderCancel, renderReschedule]);

  if (!hasActions) return null;

  return (
    <Popover
      trigger="click"
      placement="top"
      open={open}
      onOpenChange={setOpen}
      content={menu}
      overlayClassName="manage-booking-actions__popover"
    >
      <button
        type="button"
        className={`manage-booking-actions__trigger ${className}`.trim()}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
        <span>Manage booking</span>
      </button>
    </Popover>
  );
};

export default ManageBookingActions;
